export default __webpack_public_path__ + "static/media/logo-pran.6b5ee668.jpg";